import { HardHat, Timer, TrendingUp } from "lucide-react";
import { WHY } from "../../lib/content";
import { Reveal } from "./Reveal";

const ICONS = [HardHat, Timer, TrendingUp];

export const WhyUs = () => (
  <section id="pourquoi-nous" data-testid="why-section" className="scroll-mt-20 bg-cs-grey py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal className="mb-12 max-w-2xl md:mb-16">
        <span className="eyebrow">Notre différence</span>
        <h2 className="section-title">Pourquoi nous</h2>
      </Reveal>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {WHY.map((w, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal
              key={w.title}
              delay={i * 0.1}
              data-testid={`why-card-${i + 1}`}
              className="relative rounded-xl border border-cs-navy/10 bg-white p-7 md:p-8"
            >
              <span className="absolute left-0 top-8 h-10 w-1 rounded-r bg-cs-yellow" />
              <span className="grid h-12 w-12 place-items-center rounded-lg bg-cs-navy text-cs-yellow">
                <Icon className="h-6 w-6" strokeWidth={2} />
              </span>
              <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-cs-navy">{w.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-cs-ink/75">{w.text}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
